import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import Card from 'react-bootstrap/esm/Card'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import Button from 'react-bootstrap/esm/Button'
import { toast } from 'react-toastify'
import SweetAlert from '../../Components/SweetAlert/SweetAlert'
import Loading from '../../Components/Layout/Styled/Loading'
import ReactPlaceholder from 'react-placeholder/lib'
import { FormCustom, Input } from '../../Components/Form/Form'

const Encuesta2 = () => {
  const [encuesta, setEncuesta] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [ready, setReady] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const [user, setUser] = useState({
    p_name_user: '',
    p_age_user: '',
    p_job_user: ''
  })

  useEffect(() => {
    Controllers.encuesta.encuesta_2_questions().then((res) => {
      setEncuesta(res.data/* .filter(ec => ec.yes_no === true) */)
      setReady(true)
    })
  }, [])

  const onSubmit = () => {
    let hasError = false
    let questionError = null;

    encuesta.forEach((section) => {
      if (section.id > 1) {
        if (encuesta[0].items[0].options.some(op => op.checked === true && op.value === 'SI')) {
          section.items.forEach((item) => {
            if (!hasError) {
              if (!item.options.some(op => op.checked === true)) {
                hasError = true
                questionError = `${item.id}.- ${item.title}`
              }
            }
          })
        }
      } else {
        section.items.forEach((item) => {
          if (!hasError) {
            if (!item.options.some(op => op.checked === true)) {
              hasError = true
              questionError = `${item.id}.- ${item.title}`
            }
          }
        })
      }
    })

    if (hasError) {
      Helpers.toast.construct({
        message: `Debe seleccionar una opción en la pregunta: ${questionError}`,
        response: 'info',
        toast
      })
      return
    }

    console.log(encuesta)

    setIsLoading(true)
    Controllers.encuesta.encuesta_2_save({
      p_encuesta: JSON.stringify(encuesta),
      ...user
    }).then(() => {
      setIsLoading(false)
      setShowPopup(true)
    })
  }

  return (
    <div className="container mt-4 mb-5">
      <div className="form-row">
        <div className="col-12">
          <Card>
            <Card.Body>
              <div className="text-center mb-4">
                <h6 className='text-primary'>CUESTIONARIO PARA IDENTIFICAR A LOS TRABAJADORES QUE FUERON SUJETOS A ACONTECIMIENTOS TRAUMÁTICOS SEVEROS</h6>
              </div>

              <ReactPlaceholder rows={15} ready={ready} showLoadingAnimation>
                <FormCustom viewSubmit={false} onSubmit={onSubmit}>
                  <Input
                    text="Nombres*"
                    placeholder="Nombres"
                    classNameParent="col-12 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_name_user: e.currentTarget.value })}
                    maxLength={100}
                    minLength={5}
                  />
                  <Input
                    type="number"
                    text="Edad*"
                    placeholder="Edad"
                    classNameParent="col-md-6 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_age_user: e.currentTarget.value })}
                    min={15}
                    max={99}
                  />
                  <Input
                    text="Puesto de Trabajo*"
                    placeholder="Nombres"
                    classNameParent="col-md-6 mb-2"
                    required
                    invalid="El campo es obligatorio."
                    onChange={e => setUser({ ...user, p_job_user: e.currentTarget.value })}
                    maxLength={100}
                    minLength={5}
                  />

                  <div className="col-12">
                    <div className="d-flex flex-column mt-3">
                      {React.Children.toArray(encuesta.filter((item, idx) => {
                        if (item.id > 1) {
                          if (!encuesta[0].items[0].options.some(op => op.checked === true && op.value === 'SI')) {
                            return false
                          }
                        }

                        return item
                      }).map((section, idxSec) => {

                        return <div className='mb-4'>
                          <div className='mb-2'>
                            <small>{section.title}</small>
                          </div>
                          {<>
                            <div className="d-flex flex-column">
                              {React.Children.toArray(section.items.map((item, idxIt) => {
                                return <div className='mb-3'>
                                  <div className='mb-2'>
                                    <div dangerouslySetInnerHTML={{
                                      __html: `<div>
                                        <small><strong>${item.titleHTML ? item.titleHTML : item.title}</strong></small>
                                      </div>`
                                    }} />
                                  </div>
                                  {React.Children.toArray(item.options.map((option, idxOpt) => {
                                    return <div className='ml-3'>
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          id={`section_${section.id}_item_${item.id}_option_${option.id}`} name={`section_${section.id}_item_${item.id}`}
                                          value={option.value}
                                          checked={option.checked === true}
                                          onChange={() => {
                                            const newEncuesta = [...encuesta]
                                            newEncuesta[idxSec].items[idxIt].options = newEncuesta[idxSec].items[idxIt].options.map(op => {
                                              op.checked = false
                                              return op
                                            })

                                            newEncuesta[idxSec].items[idxIt].options[idxOpt].checked = true
                                            setEncuesta(newEncuesta)
                                          }}
                                        />
                                        <label
                                          className="form-check-label"
                                          htmlFor={`section_${section.id}_item_${item.id}_option_${option.id}`}>
                                          {option.title}
                                        </label>
                                      </div>
                                    </div>
                                  }))}
                                </div>
                              }))}
                            </div>
                          </>}
                        </div>
                      }))}
                    </div>

                    <div className='mb-2'>
                      <Button block type="submit">
                        Enviar Encuesta
                      </Button>
                    </div>
                  </div>
                </FormCustom>
              </ReactPlaceholder>
            </Card.Body>
          </Card>
        </div>
      </div>
      <Loading show={isLoading}>
        <Loading.Img src={Helpers.config.resourcesUrl({ url: '/images/dashboard/preloading.svg' })} alt="Preloading" />
      </Loading>
      <SweetAlert
        icon="info"
        show={showPopup}
        showCancelButton={false}
        title={<>¡Gracias por completar la encuesta!</>}
        subtitle={<>Ya puedes cerrar esta ventana</>}
      />
    </div>
  )
}

export default Encuesta2